module.exports = __webpack_public_path__ + "img/superiority2.42055d4.png";